import Reveal from 'stimulus-reveal-controller';

export default class extends Reveal {
  static targets = ['html', 'link', 'pdf'];

  connect() {
    super.connect();
  }

  toggleByOpt(e) {
    this.selectedOpt = e.currentTarget.value;
    if (this.selectedOpt === 'pdf') {
      this.htmlTarget.classList.add(this.hiddenClass);
      this.linkTarget.classList.add(this.hiddenClass);
      this.pdfTarget.classList.remove(this.hiddenClass);
    } else if (this.selectedOpt === 'link') {
      this.htmlTarget.classList.add(this.hiddenClass);
      this.linkTarget.classList.remove(this.hiddenClass);
      this.pdfTarget.classList.add(this.hiddenClass);
    } else if (this.selectedOpt === 'html' || this.selectedOpt === 'video') {
      this.htmlTarget.classList.remove(this.hiddenClass);
      this.linkTarget.classList.add(this.hiddenClass);
      this.pdfTarget.classList.add(this.hiddenClass);
    }
  }
}
